/**
 * api请求
 */
import axios from 'axios'
import {
    localToken,
    cache,
    toolFunc
} from '@/libs/func';
import globConfig from '@/config/config';
class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl;
        this.queue = {}
    }

    getInsideConfig() {
        return {
            baseURL: this.baseUrl,
            timeout: 13000,
            headers: {}
        };
    }

    distroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) { }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;
            //是否无需access_token 的方法 start
            let whiteMethod = false;
            let whiteMethodList = globConfig.apiWhite || [];
            for (let i = 0; i < whiteMethodList.length; i++) {
                if (url.indexOf(whiteMethodList[i]) > -1) {
                    whiteMethod = true;
                    break;
                }
            }
            if (whiteMethod) {
                //白名单方法 无需access_token
                config.headers.Authorization = "";
            } else {
                //获取本地存放的token
                let access_token = localToken.get();
                if (!access_token || typeof (access_token) == 'undefined') { //token有问题
                    localToken.clearLocal();
                    return;
                }
                config.headers.Authorization = access_token;
            }
            return config
        }, error => {
            return Promise.reject(error)
        });

        // 响应拦截
        instance.interceptors.response.use(res => {
            console.log(res, '响应数据');
            this.distroy(url);
            let data = res.data;
            // if (url.indexOf('login') > -1) {
            //     // 登录接口 && res.status === true
            //     if (typeof res.status !== 'undefined' && res.status === 200 && typeof res.data.value.token !== 'undefined' && res.data.value.token !== null) {
            //         let token =
            //             data.value.token.token_type + " " + data.value.token.access_token || ""; //token值
            //         let expires = data.value.token.expires_in || 7200;
            //         localToken.set(token, expires); //存储token（已经登录的token）
            //         let tenantID = "d675e4a4-ba49-4f57-bd83-893c5fbd99bb";
            //         localToken.setTenant(tenantID, expires); //存储商户id
            //     }
            //     return data
            // } else
            if (true === data.success && null === data.error) {
                //返回正确的内容就返回纯数据
                console.log('api正确返回数据', res.data.value);
                return res.data.value || [];
            } else {
                //没有返回正确的内容 直接走error
                console.log('来这里了');
                return Promise.reject(data.error);
            }
        }, error => {
            this.distroy(url);
            return Promise.reject(error)
        })
    }

    //通用请求
    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options)
    }

    //增加几种常用方式
    get(options) {
        options = Object.assign({
            method: 'get'
        }, options);
        return this.request(options);
    }

    post(options) {
        let tenantID = localToken.getTenant();
        options = Object.assign({
            method: 'post'
        }, options);
        if (options.data != undefined) {
            options.data["TenantId"] = tenantID;
        }
        return this.request(options);
    }

    put(options) {
        options = Object.assign({
            method: 'put'
        }, options);
        return this.request(options);
    }

    del(options) {
        options = Object.assign({
            method: 'delete'
        }, options);
        return this.request(options);
    }

    path(options) {
        options = Object.assign({
            method: 'path'
        }, options);
        return this.request(options);
    }

    parseParams(data) {
        try {
            // 20190806参数批量添加商户id start
            let tempArr = [];
            // 如果商户id有问题，清空token，请求失败
            let tenantID = localToken.getTenant();
            if (!tenantID) {
                localToken.clearLocal();
                return;
            } else {
                tempArr.push('TenantId=' + tenantID)
            }
            // 20190806参数批量添加商户id end
            for (let i in data) {
                let key = encodeURIComponent(i);
                let value = encodeURIComponent(data[i]);
                tempArr.push(key + '=' + value);
            }
            return tempArr.join('&');

        } catch (err) {
            return '';
        }
    }

}

export default HttpRequest


// WEBPACK FOOTER //
// ./src/libs/api.axios.js